var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLineLeftS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowLineLeft-s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9254 5.05806C13.1915 5.30214 13.1915 5.69786 12.9254 5.94194L8.4375 10.0581C8.17138 10.3021 8.17138 10.6979 8.4375 10.9419L12.9254 15.0581C13.1915 15.3021 13.1915 15.6979 12.9254 15.9419C12.6593 16.186 12.2278 16.186 11.9617 15.9419L7.47378 11.8258C6.67541 11.0936 6.67541 9.90641 7.47378 9.17418L11.9617 5.05806C12.2278 4.81398 12.6593 4.81398 12.9254 5.05806Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLineLeftS);
export default __webpack_public_path__ + "static/media/ArrowLineLeft-s.329724fa038926659ffc61ad5d6165bd.svg";
export { ForwardRef as ReactComponent };